export default __webpack_public_path__ + "static/challenge-patrik-1717ee69d34b74b76d6e03882758255c.jpg";